import {
    Featured,
    ForYou,
    FeaturedBpmOriginal,
    PromotionsMessagingModal,
    useLibraryTabs,
    TrendingBrowseSupreme,
    ExclusivePlaylistsBrowse,
    Library,
    FeaturedArtists,
    DownloadPageLayout,
    FeaturedEditors,
    PlaylistsBrowse
} from '@bpm-web-app/components';
import { Banner, MessageBanner, AnonymousUserBanner } from '@bpm-web-app/components/shared';
import { useHubSwitch, useUserSettings } from '@bpm-web-app/utils';
import { useMemo, useState } from 'react';

export default function Index({ title }: { title: string }) {
    const { isDownload } = useHubSwitch();
    const { isAnonymous } = useUserSettings();
    const { libraryProperty, library } = useLibraryTabs();
    const [isBannersLoaded, setIsBannersLoaded] = useState(false);
    const [isFeaturedLoaded, setIsFeaturedLoaded] = useState(false);
    const [isExclusivePlaylistsLoaded, setIsExclusivePlaylistsLoaded] = useState(false);
    const [isCollectionsLoaded, setIsCollectionsLoaded] = useState(!(library !== 'artist'));
    const [isChartsLoaded, setisChartsLoaded] = useState(!(library !== 'artist'));
    const [isTrendingLoaded, setIsTrendingLoaded] = useState(false);
    const [isForYouLoaded, setIsForYouLoaded] = useState(!(library !== 'artist' && !isAnonymous));
    const [isFeaturedBPMOriginalsLoaded, setIsFeaturedBPMOriginalsLoaded] = useState(!(library !== 'artist'));
    const [isFeaturedArtistsLoaded, setIsFeaturedArtistsLoaded] = useState(false);
    const [isFeaturedEditorsLoaded, setIsFeaturedEditorsLoaded] = useState(false);

    const isEverythingLoaded = useMemo(() => {
        // Check for Anonymous (doesn't load ForYou section).
        if (isAnonymous && isBannersLoaded &&
            isFeaturedLoaded &&
            isExclusivePlaylistsLoaded &&
            isTrendingLoaded &&
            isCollectionsLoaded &&
            isChartsLoaded &&
            isFeaturedBPMOriginalsLoaded &&
            isFeaturedEditorsLoaded
        ) return true;

        // Check for everything being loaded.
        if (isBannersLoaded &&
            isFeaturedLoaded &&
            isExclusivePlaylistsLoaded &&
            isTrendingLoaded &&
            isForYouLoaded &&
            isCollectionsLoaded &&
            isChartsLoaded &&
            isFeaturedBPMOriginalsLoaded &&
            isFeaturedEditorsLoaded
        ) return true;

        // Check for White Label (doesn't load ExclusivePlaylists ad Top Editors section).
        if (library === Library.Artist && isBannersLoaded &&
            isFeaturedLoaded &&
            isExclusivePlaylistsLoaded &&
            isTrendingLoaded &&
            isFeaturedArtistsLoaded
        ) return true;

        return false;
    }, [
        isAnonymous,
        isBannersLoaded,
        isExclusivePlaylistsLoaded,
        isFeaturedArtistsLoaded,
        isCollectionsLoaded,
        isFeaturedBPMOriginalsLoaded,
        isFeaturedLoaded,
        isFeaturedEditorsLoaded,
        isChartsLoaded,
        isForYouLoaded,
        isTrendingLoaded,
        library,
    ]);
    return (
        <DownloadPageLayout title={title}>
            {isAnonymous ? <MessageBanner type="info" title="You’re currently previewing BPM Supreme." viewPlanRoute /> : null}
            <Banner platform={isDownload ? 'download' : 'stream'} library={libraryProperty} isDataLoaded={isEverythingLoaded} setIsDataLoaded={setIsBannersLoaded} />
            {library !== 'artist' ? <FeaturedBpmOriginal isDataLoaded={isEverythingLoaded} setIsDataLoaded={setIsFeaturedBPMOriginalsLoaded} /> : null}
            {library !== 'artist' && <FeaturedEditors isDataLoaded={isEverythingLoaded} setIsDataLoaded={setIsFeaturedEditorsLoaded} />}
            {library !== 'artist' ? <PlaylistsBrowse isDataLoaded={isEverythingLoaded} setIsDataLoaded={setIsCollectionsLoaded} categoryId={59} /> : null}
            <Featured seeMorePath="/releases" isDataLoaded={isEverythingLoaded} setIsDataLoaded={setIsFeaturedLoaded} />
            {library !== 'artist' ? <PlaylistsBrowse isDataLoaded={isEverythingLoaded} setIsDataLoaded={setisChartsLoaded} categoryId={32} title="Charts" /> : null}
            {library === 'artist' ? <FeaturedArtists isDataLoaded={isEverythingLoaded} setIsDataLoaded={setIsFeaturedArtistsLoaded} /> : null}
            <AnonymousUserBanner />
            <ExclusivePlaylistsBrowse isDataLoaded={isEverythingLoaded} setIsDataLoaded={setIsExclusivePlaylistsLoaded} />
            <TrendingBrowseSupreme isDataLoaded={isEverythingLoaded} setIsDataLoaded={setIsTrendingLoaded} />
            {library !== 'artist' && <PlaylistsBrowse isDataLoaded={isEverythingLoaded} categoryId={60} title="Editor Picks" />}
            {library !== 'artist' && !isAnonymous ? <ForYou isDataLoaded={isEverythingLoaded} setIsDataLoaded={setIsForYouLoaded} /> : null}
            <PromotionsMessagingModal />
        </DownloadPageLayout>
    );
}

export async function getStaticProps() {
    return {
        props: {
            title: 'Home',
        },
    };
}
